import {
  Button,
  Modal,
  TextField,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Checkbox,
  Box,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import request from "../../../Helpers/API";
import { LoaderScreen } from "../../components/LoaderScreen";

export const ModalGuardarTelefono = ({ open, handleCloseModal, idcliente }) => {
  const [datosContacto, setDatosContacto] = useState({
    idcliente: "",
    valor: "",
  });
  const [loader, setLoader] = useState({
    mostrar: false,
    alerta: false,
    error: false,
    mensaje: "",
  });

  useEffect(() => {
    console.log(idcliente);
    setDatosContacto((prevState) => ({ ...prevState, idcliente }));
  }, [idcliente]);

  const handleTextChange = (event) => {
    if (/^\d*$/.test(event.target.value) && event.target.value.length <= 10) {
      setDatosContacto({
        ...datosContacto,
        [event.target.id]: event.target.value,
      });
    }
  };

  // console.log(datosContacto)
  const handleAdd = () => {
    setLoader({ ...loader, mostrar: true });
    if (datosContacto.valor.length < 10) {
      setLoader({ ...loader, mostrar: false });
      Swal.fire("Advertencia", "El número debe tener 10 dígitos.", "warning");
      return;
    } else {
      request
        .get(
          `GuardaPlantillasKarbot/GuardarTelefono?idcliente=${idcliente}&telefono=${datosContacto.valor}`
        )
        .then((response) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire(
            "Éxito",
            "Los datos de contacto se han guardado correctamente.",
            "success"
          );
          handleCloseModal();
        })
        .catch((error) => {
          setLoader({ ...loader, mostrar: false });
          Swal.fire(
            "Error",
            "Ocurrió un error al guardar los datos de contacto.",
            "error"
          );
        });
    }
  };

  return (
    <Modal open={open} onClose={handleCloseModal}>
      <div className="dash-clientes-credito-crear-solicitud-modal">
        <LoaderScreen loader={loader} />
        <div className="credito-agregar-modal-title">
          <div className="filtro-soy-el-titulo-header">
            <h3>GUARDAR NÚMERO DE TELÉFONO</h3>
          </div>
        </div>
        <div className="modal-tasa-intereses-filtro-soy-el-titulo-line">
          <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-bl"></div>
          <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-circle"></div>
          <div className="modal-tasa-intereses-filtro-soy-el-titulo-line-br"></div>
        </div>

        <div>
          <TextField
            id="valor"
            label="Teléfono"
            sx={{ mb: 2, width: 540 }}
            value={datosContacto.valor}
            onChange={handleTextChange}
          />

          <div className="credito-crear-tasa-interes-modal-button-container">
            <Button
              onClick={() => handleCloseModal()}
              variant="contained"
              color="error"
            >
              Cerrar
            </Button>
            <Button onClick={handleAdd} variant="contained">
              Guardar
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
